module.exports = __webpack_public_path__ + "img/icon-edit.0fbfe4c5.svg";